import type { GTMEventReturnType } from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';

interface GTMOverviewMapHousePreviewModelReturnType extends GTMEventReturnType {
    house_id: string;
}

interface GTMOverviewMapHousePreviewModelData {
    houseId: string;
}

export default class GTMOverviewMapHousePreviewModel extends GTMBaseModel {
    public static parseToGTMData({
        houseId
    }: GTMOverviewMapHousePreviewModelData): GTMOverviewMapHousePreviewModelReturnType {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'cro_event',
            ga4_event_name: 'overview_map_house_preview',
            house_id: houseId
        };
    }
}
